/** @jsx jsx */
import { jsx } from '@emotion/react';

import * as React from 'react';
import { useState } from 'react';

import type { CareerRolesFieldsFragment } from 'bundles/front-page/__generated__/contentfulTypes';
import { CAREER_ROLE_CARD_WIDTH } from 'bundles/front-page/common/constants';
import CareerRoleCard from 'bundles/front-page/components/modules/career-roles/CareerRoleCard';
import CareerRoleRecommendationsModal from 'bundles/front-page/components/modules/career-roles/CareerRoleRecommendationsModal';
import Slider from 'bundles/front-page/components/modules/slider/Slider';

type Props = {
  roles: CareerRolesFieldsFragment[];
  countryCode?: string;
};

const CareerRolesSliderModalController = ({ roles, countryCode }: Props) => {
  // create arrary of booleans to track which modal is open
  const [openModals, setOpenModals] = useState<boolean[]>(Array.from({ length: roles.length }, () => false));

  const handleOpenModal = (index: number) => {
    setOpenModals((prevOpenModals) => prevOpenModals.map((_, i) => i === index));
  };

  const handleCloseModal = (index: number) => {
    setOpenModals((prevOpenModals) => prevOpenModals.map((open, i) => (i === index ? false : open)));
  };

  // Need to render the modals outside of the slider/cards or else they don't work on mobile
  return (
    <React.Fragment>
      <Slider forcedCardWidth={CAREER_ROLE_CARD_WIDTH}>
        {roles.map((role, index) => (
          <CareerRoleCard
            role={role}
            countryCode={countryCode}
            key={role.sys.id}
            openModal={() => handleOpenModal(index)}
          />
        ))}
      </Slider>
      {roles.map((role, index) => (
        <CareerRoleRecommendationsModal
          role={role}
          open={openModals[index]}
          setOpen={() => handleCloseModal(index)}
          key={`${role.title}_recommendation_modal`}
        />
      ))}
    </React.Fragment>
  );
};

export default CareerRolesSliderModalController;
